import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { rupiah } from "@/lib/format";
import { tripStartPrice } from "@/lib/pricing";

export const TripCard = ({ trip, index }) => (
  <Link
    to={`/trip/${trip.id}`}
    data-testid={`trip-card-${trip.id}`}
    className="group relative block overflow-hidden rounded-2xl border border-white/10 bg-ink-850"
  >
    <div className="relative aspect-[4/5] overflow-hidden">
      <img
        src={trip.image_url || "/images/hikers.jpg"}
        alt={trip.name}
        loading="lazy"
        className="h-full w-full object-cover transition-transform [transition-duration:1400ms] ease-out group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/45 to-black/10" />
      <div className="absolute inset-x-5 top-5 flex items-center justify-between font-mono text-xs sm:inset-x-7 sm:top-7">
        <span className="text-white/60">{String(index + 1).padStart(2, "0")}</span>
        {trip.elevation > 0 && (
          <span className="rounded-full border border-white/20 bg-black/40 px-3 py-1 text-white/90 backdrop-blur-md">
            {trip.elevation.toLocaleString("id-ID")} mdpl
          </span>
        )}
      </div>
      <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8">
        <p className="overline-label">{trip.location}</p>
        <h3 className="mt-3 font-display text-3xl leading-[1.1] sm:text-4xl">{trip.mountain || trip.name}</h3>
        <div className="mt-4 flex flex-wrap gap-2">
          {trip.packages.map((p) => (
            <span key={p.id} className="rounded-full border border-white/15 bg-black/30 px-3 py-1 text-xs text-white/75 backdrop-blur-md">
              {p.name}
            </span>
          ))}
        </div>
        <div className="mt-6 flex items-end justify-between border-t border-white/10 pt-5">
          <div>
            <p className="text-xs text-white/50">Mulai dari</p>
            <p className="font-mono text-lg text-gold-light" data-testid={`trip-card-price-${trip.id}`}>
              {rupiah(tripStartPrice(trip))}
            </p>
          </div>
          <span
            data-testid={`trip-btn-book-${trip.id}`}
            className="flex h-12 w-12 items-center justify-center rounded-full bg-gold text-black transition-transform duration-500 group-hover:rotate-45"
          >
            <ArrowUpRight className="h-5 w-5" />
          </span>
        </div>
      </div>
    </div>
  </Link>
);
